module.exports = __webpack_public_path__ + "img/archive.2d40124d.svg";